import { Page } from '../../../design/page/Page';
import { EikenMaterialList } from './components/EikenMaterialList';
import { ListFilter } from './components/ListFilter';
import { ListPageHeader } from './components/ListPageHeader';
import { ListSearchFilterProvider } from './context/useListSearchFilter';

export function EikenMaterialListPage() {
  return (
    <ListSearchFilterProvider>
      <Page>
        <Page.Header>
          <ListPageHeader />
        </Page.Header>
        <Page.Content>
          <ListFilter />
          <EikenMaterialList />
        </Page.Content>
      </Page>
    </ListSearchFilterProvider>
  );
}
